module.exports = __webpack_public_path__ + "static/media/the-nightly-app-download.8645158b.webp";